// utils/cn.ts
import { ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge class names (incl. conditional ones) and dedupe Tailwind utilities.
 *
 * @param inputs  any number of ClassValue args (strings, arrays, objects, etc.)
 * @returns       a single, merged className string
 */
export function cn(...inputs: ClassValue[]): string {
  // early return if nothing passed
  if (inputs.length === 0) return "";

  // clsx handles conditional logic; twMerge dedupes Tailwind classes
  return twMerge(clsx(...inputs));
}
